/** @module Apparel/3DDrapeForm **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/_3DFileValidationMixin",
	"csi/def",
	"csi/def/Field",
	"csi/html",
	"csi/form/Widget",
	"csi/locale",
	"csi/util",
	"csi/xml"
], function(declare,lang,csi,ThreeDFileValidationMixin,def,Field,html,Widget,locale,util,xml) {
	var SOURCE_FILE = "SourceFile";

	return declare([ThreeDFileValidationMixin, Widget], {
		fileIndexNode: null,
		warnMsg: "",

		/** @property {boolean} ignoreMtl - skips validating for mtl files in zip content*/
		ignoreMtl: true,

		constructor: function() {
			this._initializeFileType("json,obj");
			this.fileLabel = locale.resource("3DPhysicsZip");
		},

		startup: function() {
			var dfd = this.inherited(arguments);

			if (!this.messageRowCreated) {
				//fill in default message when no files are selected
				this.on3DZipFile(true, null, this.threeFileSuffix.json);
				this.on3DZipFile(true, null, this.threeFileSuffix.obj);
				this.messageRowCreated = true;
			}

			return dfd;
		},

		/**
		 * Creates the file message row
		 * @param {boolean} [bIsRequired]
		 * @param {string} [fileName]
		 * @param {string} [defaultName]
		 */
		on3DZipFile: function(bIsRequired, fileName, defaultName) {
			//move required items to top of the row
			if(!bIsRequired && !fileName) {
				return;
			}

			var messageRowNode = html.create("div", {
				"class": "csi-3Dform-fileIndex-row"
			}, this.fileIndexNode, bIsRequired && "first");

			html.create("div", {
				innerHTML: (bIsRequired ? (fileName ? 'check_circle' : 'brightness_1') : '&nbsp;'),
				"class": "csi-3Dform-fileIndex-left"+ (bIsRequired ? (" material-icons "+ (fileName ? "csi-status-ok" : "")) : "")
			}, messageRowNode);

			html.create("div", {
				innerText: fileName || defaultName,
				"class": "csi-3Dform-check-message"
			}, messageRowNode);
		},

		/**
		 * Extension point on3Dzip file selection
		 * @param {array} val
		 */
		onZipRead: function(val) { },

		/**
		 * Form validation , make Data value available to action controller
		 * @param {Object} errorParams
		 */
		validateForm: function(errorParams) {
			var val = this.inherited(arguments);
			var formData = this.defView.getFormData();
			var field = formData.getField(SOURCE_FILE);
			var documentName = this.defView.getFieldValue(xml.ATTR_NAME);

			if(field && field.errorMessage) {
				errorParams.message = field.errorMessage;
				val = false;
			} else if(!field) {
				field = this.getField(SOURCE_FILE);
				errorParams.message = locale.resource(!documentName ? "Error3DNoFileName" : (field.getValue() ? "" : "Error3DNoFile") );
				val = false;
			}
			return val;
		},

		/**
		 * Change Label for upload field
		 */
		_resolveView: function() {
			this.inherited(arguments);
			var fileField = this.getField(SOURCE_FILE);
			fileField.widgetParams.accept = ".zip";
			fileField.m_label = this.fileLabel;
		},

		/**
		 * On file select check if its a valid zip file
		 * @param {Obj} defView
		 * @param {Field} field
		 * @param {Any} value
		 */
		_onChangeFileField: function(defView, field, value) {
			var self = this;
			var bWarning = false;

			//Set wanted file object
			var fileToRead = field.m_control.files[0];
			$(this.fileIndexNode).empty();

			if(!fileToRead) {
				//fill in default message when no files are selected
				this.on3DZipFile(true, null, this.threeFileSuffix.json);
				this.on3DZipFile(true, null, this.threeFileSuffix.obj);
			} else {
				//pre-fill Document name field from file name if the field is blank
				var textField = this.getField(xml.ATTR_NAME);

				if (textField.isDefaultValue() || !textField.getValue()) {
					var fileName = fileToRead.name.substr(0, fileToRead.name.lastIndexOf('.'));
					this.setFieldValue(textField, fileName);
				}
			}

			field.errorMessage = "";
			this.warnMsg = "";
			this.validate3DZip(fileToRead).then(function(val) {
				bWarning = !!val.bWarning;
				field.errorMessage = bWarning ? "" : val.message;
				self.warnMsg = bWarning && val.message;
				self.errorForm(field.errorMessage);
				self.onZipRead(val);
			});

		}
	});
});